module.exports = __webpack_public_path__ + "static/media/instagram.31b7b026.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instagram.svg
// module id = 356
// module chunks = 25